import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { text: String }
  
  copy() {
    navigator.clipboard.writeText(this.textValue).then(() => {
      // Flash temporaire de succès
      const originalText = this.element.innerHTML
      this.element.innerHTML = `
        <svg class="h-3 w-3 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
        </svg>
        Copié !
      `
      this.element.classList.add('text-green-700', 'bg-green-50', 'border-green-300')
      this.element.classList.remove('text-blue-700', 'bg-white', 'border-blue-300')
      
      setTimeout(() => {
        this.element.innerHTML = originalText
        this.element.classList.remove('text-green-700', 'bg-green-50', 'border-green-300')
        this.element.classList.add('text-blue-700', 'bg-white', 'border-blue-300')
      }, 2000)
    }).catch(err => {
      console.error('Failed to copy text: ', err)
    })
  }
}